


































import CAMPAIGN_STATUS_LIST from "@/constants/campaign";
import AdUnit from "@/models/adUnit";
import {
  AvailabilityEvent,
  AvailabilityFilterModel,
} from "@/models/availability";
import Campaign, { LineItem } from "@/models/campaign";
import { DefinitionList } from "@/models/definition";
import { QueryParams } from "@/models/general";
import Site from "@/models/site";
import CampaignsAPI from "@/services/campaigns";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class CalendarAvailability extends Vue {
  @Prop({ default: () => [] }) sites!: Site[];
  @Prop({ default: () => [] }) adUnits!: AdUnit[];
  @Prop({ default: () => [] }) campaigns!: Campaign[];
  @Prop({ default: () => [] }) definitions!: DefinitionList[];
  @Prop({ default: null }) filter!: AvailabilityFilterModel;

  weekday = [1, 2, 3, 4, 5, 6, 0];
  value = "";
  lineItems: any[] = [];
  current_date_range = {
    start: {},
    end: {},
  };

  get startDate() {
    return this.filter.start ? this.filter.start : Date.now();
  }

  @Watch("filter", { deep: true })
  applyFilter(): void {
    this.getEvents(this.current_date_range);
  }

  async getEvents({ start, end }: any): Promise<void> {
    const events: AvailabilityEvent[] = [];
    const min = new Date(`${start.date}T00:00:00`);
    const max = new Date(`${end.date}T23:59:59`);
    this.current_date_range.start = start;
    this.current_date_range.end = end;

    const params: QueryParams = {
      page: {
        size: -1,
      },
      filter: {
        // ad_units: this.filter.ad_units.join(","),
        // site_id: "",
        start: min,
        end: max,
      },
    };

    this.filter !== null && this.filter.ad_units !== undefined
      ? ((params.filter as AvailabilityFilterModel).ad_units = (this.filter
          .ad_units as string[]).join(","))
      : null;

    this.filter !== null && this.filter.site_id !== undefined
      ? ((params.filter as AvailabilityFilterModel).site_id = this.filter.site_id)
      : null;

    const r = await CampaignsAPI.lineItems.all(params);

    const lineItems = r.data;

    lineItems.forEach((lineItem: LineItem) => {
      const campaign = this.getCampaign(lineItem.campaignId);
      const adUnit = this.getAdUnit(lineItem.adUnitId);
      const name = `${adUnit.name} - ${campaign.name} `;
      // console.log(this.definitions);
      events.push({
        name: name,
        start: lineItem.start,
        end: lineItem.end,
        color: this.getEventColor(campaign.status),
      });
    });

    this.lineItems = events;
  }

  getEventColor(status: string): string | undefined {
    const color = CAMPAIGN_STATUS_LIST.find((e) => e.key === status);
    return color ? color.color : "#CCCCCC";
  }

  getCampaign(campaign_id?: string): Campaign {
    const campaign: Campaign | undefined = this.campaigns.find(
      (e) => e.id === campaign_id
    );
    return campaign ? campaign : new Campaign();
  }

  getAdUnit(ad_unit_id: string): AdUnit {
    const adUnit: AdUnit | undefined = this.adUnits.find(
      (e) => e.id === ad_unit_id
    );
    return adUnit ? adUnit : new AdUnit();
  }
}
